import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { extendTeachingStylesheet } from "@devowl-wp/web-cookie-banner";
import { useStylesheet } from "../../../contexts/stylesheet.js";
import { useBannerOrBlocker } from "../../../hooks/useBannerOrBlocker.js";
const BodyDescription = ({ description, nl2br, teachings, isPostamble, children, ...rest })=>{
    const { individualPrivacyOpen } = useBannerOrBlocker();
    const { DescriptionContainer, Teaching, TeachingSeparator } = useStylesheet().extend(...extendTeachingStylesheet);
    return /*#__PURE__*/ _jsxs(DescriptionContainer, {
        style: [
            true,
            // For content blockers, automatically use the "individual layout" text align
            undefined
        ].indexOf(individualPrivacyOpen) > -1 ? undefined : {
            textAlign: "inherit"
        },
        children: [
            children,
            !!description && /*#__PURE__*/ _jsx("p", {
                role: "presentation",
                ...rest,
                dangerouslySetInnerHTML: {
                    __html: nl2br ? description.replace(/\n/gm, '<br aria-hidden="true" />') : description
                }
            }),
            teachings?.length > 0 && /*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    (!!description || isPostamble) && /*#__PURE__*/ _jsx(TeachingSeparator, {}),
                    teachings.map((teaching)=>typeof teaching === "string" ? /*#__PURE__*/ _jsx(Teaching, {
                            style: {
                                marginBottom: isPostamble ? 7 : 0
                            },
                            dangerouslySetInnerHTML: {
                                __html: teaching
                            }
                        }, teaching) : teaching)
                ]
            })
        ]
    });
};
export { BodyDescription };
